import {
  faInstagram, faFacebook, faTwitter, faYoutube, faTiktok,
  faTelegram, faSpotify, faSoundcloud, faTwitch, faDiscord,
  faSnapchat, faPinterest, faLinkedin, faReddit, faWhatsapp,
  faGithub, faMedium, faVimeo, faTumblr,
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const known = {
  instagram: faInstagram,
  facebook: faFacebook,
  twitter: faTwitter,
  youtube: faYoutube,
  tiktok: faTiktok,
  telegram: faTelegram,
  spotify: faSpotify,
  soundcloud: faSoundcloud,
  twitch: faTwitch,
  discord: faDiscord,
  snapchat: faSnapchat,
  pinterest: faPinterest,
  linkedin: faLinkedin,
  reddit: faReddit,
  whatsapp: faWhatsapp,
  github: faGithub,
  medium: faMedium,
  vimeo: faVimeo,
  tumblr: faTumblr,
};

const colors = {
  instagram: '#E4405F',
  facebook: '#1877F2',
  twitter: '#1DA1F2',
  youtube: '#FF0000',
  tiktok: '#000000',
  telegram: '#26A5E4',
  spotify: '#1DB954',
  soundcloud: '#FF5500',
  twitch: '#9146FF',
  discord: '#5865F2',
  snapchat: '#FFFC00',
  pinterest: '#E60023',
  linkedin: '#0A66C2',
  reddit: '#FF4500',
  whatsapp: '#25D366',
  github: '#333333',
  medium: '#00AB6C',
  vimeo: '#1AB7EA',
  tumblr: '#35465C',
};

export function getPlatformIcon(name) {
  const key = (name || '').toLowerCase().trim();
  return known[key] || faGlobe;
}

export function getPlatformColor(name) {
  const key = (name || '').toLowerCase().trim();
  return colors[key] || '#6B7280';
}
